import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { StyledTextField } from '../../../../Components/Generics.styled';
import { StyledButton } from '../../../../Components/Generics.styled';
const PrimaryProductContainer = styled.div`
    /* border: 1px solid red; */
    display: flex;
    flex-direction: column;
`;

const NavButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Btn = styled(StyledButton)`
    width: 100%;
    max-width: 360px;
    border: 1px solid white;
`;

const PrimaryProduct = ({
    handleNavButtonBack,
    handleNavButtonNext,
    teachDavieData,
    setTeachDavieData,
}) => {
    const { primaryProduct } = { ...teachDavieData };
    const [value, setValue] = useState('');

    useEffect(() => {
        if (primaryProduct !== '') {
            setValue(primaryProduct);
        }
    }, [primaryProduct]);

    const handleNext = () => {
        setTeachDavieData((prev) => ({ ...prev, primaryProduct: value }));
        handleNavButtonNext();
    };
    return (
        <PrimaryProductContainer>
            <StyledTextField
                label="What is your primary product or service?"
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                }}
                placeholder="Enter your primary product or service"
            />
            <br />
            <NavButtonContainer>
                <Btn onClick={() => handleNavButtonBack()}>Previous</Btn>
                <Btn onClick={() => handleNext()}>Next</Btn>{' '}
            </NavButtonContainer>
        </PrimaryProductContainer>
    );
};

PrimaryProduct.propTypes = {
    handleNavButtonBack: propTypes.func,
    handleNavButtonNext: propTypes.func,
    teachDavieData: propTypes.shape({}),
    setTeachDavieData: propTypes.func,
};

PrimaryProduct.defaultProps = {
    handleNavButtonBack: () => {},
    handleNavButtonNext: () => {},
    teachDavieData: {},
    setTeachDavieData: () => {},
};

export default PrimaryProduct;
